var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _ellipse5, _ellipse6, _path2, _path3, _ellipse7, _ellipse8, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse9, _path14, _path15, _ellipse10, _rect, _path16, _path17, _path18, _rect2, _ellipse11, _path19, _path20, _path21, _path22, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _path23, _ellipse16, _ellipse17, _path24, _path25, _ellipse18, _ellipse19, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _ellipse20, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 447,
    viewBox: "0 0 369 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.469,
    cy: 220.023,
    rx: 29.9748,
    ry: 37.7669,
    transform: "rotate(-31.5579 178.469 220.023)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.468,
    cy: 220.023,
    rx: 25.0134,
    ry: 33.2266,
    transform: "rotate(-31.5579 178.468 220.023)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02007,
    cy: 3.17442,
    rx: 2.02007,
    ry: 3.17442,
    transform: "matrix(0.92836 -0.373812 0.372706 0.927093 131.684 166.524)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02007,
    cy: 3.17442,
    rx: 2.02007,
    ry: 3.17442,
    transform: "matrix(-0.759429 0.651817 0.651172 0.757876 152.212 153.404)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.192 153.512C134.802 155.628 129.139 161.139 133.6 166.256C136.59 169.686 136.153 171.754 135.681 173.99C135.272 175.923 134.837 177.981 136.569 181.153C138.142 184.035 140.101 185.529 142.056 187.02C144.744 189.07 147.424 191.114 149.085 196.744C151.38 204.527 163.032 223.711 168.619 232.209L181.286 224.43L181.286 224.43L193.811 216.818C188.842 207.944 177.47 188.841 171.62 183.218C167.499 179.257 167.541 176.007 167.584 172.768C167.617 170.261 167.65 167.759 165.751 164.938C163.722 161.923 161.203 161.369 158.779 160.836C156.004 160.226 153.352 159.643 151.693 155.43C149.206 149.113 141.706 151.601 138.267 153.635L138.192 153.512Z",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.88203,
    cy: 6.87666,
    rx: 4.88203,
    ry: 6.87666,
    transform: "matrix(-0.550344 0.835582 0.835391 0.548677 138.977 173.837)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.88203,
    cy: 6.87666,
    rx: 4.88203,
    ry: 6.87666,
    transform: "matrix(-1.00003 -0.0247954 -0.0263083 0.999312 167.419 163.001)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.093 202.037C178.413 211.456 165.675 217.263 159.963 218.045L161.826 220.978C175.2 219.979 184.03 209.845 186.937 204.947L185.093 202.037Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.906 204.84C179.181 216.554 167.484 220.093 161.775 220.944L163.284 223.213C176.668 222.051 186.04 213.048 188.86 208.127L186.906 204.84Z",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 0.905879,
    cy: 1.42353,
    rx: 0.905879,
    ry: 1.42353,
    transform: "matrix(0.992509 -0.126642 0.125254 0.991564 151.018 154.994)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 0.905879,
    cy: 1.42353,
    rx: 0.905879,
    ry: 1.42353,
    transform: "matrix(0.992509 -0.126642 0.125254 0.991564 132.909 166.374)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.661 171.644C134.055 163.309 141.425 156.87 141.454 156.997C151.086 154.179 154.833 162.023 155.204 163.295C156.225 166.797 162.867 166.405 163.272 170.455C163.677 174.504 167.668 181.027 169.204 186.335C170.145 189.588 169.623 191.303 168.973 192.053C169.19 191.924 169.106 191.99 168.898 192.135C168.722 192.316 168.541 192.43 168.38 192.487C168.573 192.358 168.762 192.23 168.898 192.135C168.923 192.109 168.948 192.082 168.973 192.053C168.687 192.223 167.882 192.73 166.159 193.837C161.297 196.96 157.058 190.679 148.308 185.874C139.558 181.069 146.668 182.063 139.661 171.644Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.249 190.696C160.09 192.75 153.497 184.774 150.72 180.528C152.823 178.519 157.63 174.575 160.038 174.866C163.047 175.23 169.448 188.127 164.249 190.696Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.378 189.099C166.932 187.074 162.389 181.563 159.798 179.06L154.43 182.323C156.681 185.425 161.823 191.124 164.378 189.099Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.758 187.123C163.081 186.369 158.615 180.898 156.341 178.256L155.238 179.099C157.61 182.088 162.435 187.877 162.758 187.123Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.095 178.177C146.317 170.889 142.853 168.692 141.218 168.505C142.04 160.515 148.76 160.801 152.016 161.943C152.238 169.399 151.888 163.539 159.128 170.865C164.919 176.725 161.805 181.806 159.524 183.614C155.705 184.838 147.873 185.464 147.095 178.177Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M161.202 173.519C149.672 168.783 148.821 177.893 149.836 183.04C151.46 184.415 155.705 186.441 159.691 183.547C163.677 180.652 162.359 175.655 161.202 173.519Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.494 176.724C152.981 176.036 151.913 174.836 151.743 175.54C151.574 176.245 152.84 176.623 153.494 176.724Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.886 175.882C154.395 175.178 153.593 173.785 154.315 173.847C155.038 173.909 154.997 175.229 154.886 175.882Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.581 145.396L143.942 151.313C142.512 156.69 135.432 159.338 132.071 159.991L127.717 153.897L139.581 145.396Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.942 151.313C145.204 155.173 144.334 162.051 132.055 159.937L143.942 151.313Z",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.30377,
    cy: 1.259,
    rx: 7.30377,
    ry: 1.259,
    transform: "matrix(0.816711 -0.57849 0.577705 0.815224 126.972 152.837)",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.839 151.949C133.879 151.944 133.91 151.938 133.942 151.937C134.202 151.926 134.413 151.987 134.609 152.157C134.692 152.229 134.768 152.312 134.846 152.388C134.914 152.456 134.982 152.523 135.052 152.59C135.07 152.607 135.074 152.617 135.054 152.638C135.011 152.681 134.99 152.736 135.007 152.797C135.022 152.852 135.06 152.885 135.111 152.898C135.164 152.913 135.212 152.896 135.254 152.863C135.275 152.846 135.282 152.827 135.277 152.798C135.245 152.58 135.168 152.38 135.052 152.194C134.956 152.041 134.832 151.91 134.715 151.776C134.648 151.699 134.583 151.619 134.514 151.545C134.471 151.497 134.435 151.449 134.408 151.39C134.381 151.332 134.367 151.269 134.369 151.201C134.435 151.209 134.494 151.234 134.542 151.274C134.588 151.313 134.629 151.359 134.668 151.404C134.709 151.453 134.744 151.507 134.782 151.557C134.882 151.689 134.98 151.822 135.084 151.951C135.258 152.165 135.474 152.321 135.73 152.416C135.764 152.43 135.789 152.421 135.813 152.397C135.874 152.337 135.882 152.245 135.831 152.183C135.784 152.124 135.691 152.114 135.625 152.164C135.601 152.182 135.592 152.175 135.58 152.153C135.51 152.042 135.439 151.93 135.368 151.82C135.289 151.694 135.203 151.573 135.162 151.427C135.109 151.233 135.122 151.063 135.184 150.871C135.189 150.857 135.194 150.844 135.201 150.824C135.211 150.837 135.218 150.845 135.224 150.853C135.657 151.389 136.071 151.903 136.504 152.439C136.528 152.47 136.528 152.47 136.5 152.494C136.391 152.583 136.282 152.673 136.174 152.763C136.155 152.779 136.151 152.791 136.163 152.814C136.25 152.987 136.274 153.17 136.229 153.359C136.22 153.399 136.218 153.442 136.213 153.484C136.093 153.462 135.967 153.484 135.847 153.442C135.748 153.408 135.655 153.363 135.575 153.295C135.557 153.281 135.544 153.282 135.527 153.295C135.417 153.387 135.307 153.477 135.197 153.569C135.177 153.585 135.166 153.588 135.148 153.565C134.713 153.027 134.296 152.509 133.861 151.97C133.856 151.969 133.851 151.964 133.839 151.949ZM134.158 152.096C134.157 152.099 134.153 152.103 134.151 152.106C134.159 152.116 134.167 152.126 134.175 152.135C134.383 152.394 134.576 152.633 134.785 152.892C134.819 152.934 134.819 152.935 134.863 152.898C134.879 152.885 134.884 152.874 134.875 152.854C134.85 152.789 134.851 152.723 134.877 152.661C134.887 152.634 134.879 152.619 134.861 152.602C134.772 152.517 134.68 152.431 134.594 152.342C134.504 152.25 134.422 152.194 134.303 152.147C134.254 152.127 134.207 152.113 134.158 152.096ZM135.289 151.167C135.286 151.17 135.283 151.169 135.281 151.172C135.281 151.19 135.282 151.207 135.284 151.224C135.298 151.351 135.307 151.453 135.372 151.562C135.456 151.701 135.543 151.837 135.629 151.974C135.639 151.993 135.652 152 135.677 151.996C135.743 151.985 135.806 151.996 135.865 152.032C135.892 152.049 135.912 152.042 135.942 152.006C135.96 151.983 135.939 151.974 135.929 151.961C135.716 151.698 135.521 151.456 135.308 151.191C135.302 151.182 135.295 151.173 135.289 151.167ZM135.327 152.993C135.319 152.997 135.309 153.002 135.298 153.008C135.196 153.059 135.094 153.072 134.994 153.004C134.98 152.995 134.97 152.994 134.959 153.006C134.949 153.014 134.94 153.022 134.93 153.03C134.917 153.041 134.916 153.051 134.927 153.065C135.01 153.169 135.095 153.274 135.181 153.377C135.185 153.382 135.206 153.386 135.211 153.381C135.286 153.322 135.362 153.259 135.434 153.197C135.44 153.192 135.443 153.174 135.44 153.167C135.403 153.11 135.366 153.053 135.327 152.993ZM135.912 152.508C135.962 152.559 136.011 152.606 136.06 152.656C136.074 152.67 136.085 152.661 136.096 152.652C136.166 152.594 136.233 152.536 136.304 152.48C136.326 152.462 136.326 152.448 136.308 152.428C136.232 152.336 136.158 152.243 136.082 152.148C136.047 152.105 136.047 152.105 136.005 152.141C135.993 152.151 135.982 152.16 135.99 152.178C136.031 152.28 136.008 152.373 135.951 152.46C135.938 152.478 135.922 152.493 135.912 152.508ZM135.307 152.358C135.355 152.496 135.4 152.632 135.42 152.777C135.485 152.771 135.547 152.766 135.61 152.759C135.619 152.758 135.63 152.744 135.633 152.734C135.651 152.683 135.664 152.631 135.682 152.579C135.687 152.563 135.684 152.554 135.667 152.547C135.548 152.504 135.44 152.441 135.334 152.372C135.325 152.368 135.315 152.362 135.307 152.358ZM135.675 153.178C135.727 153.255 135.919 153.337 135.978 153.317C135.979 153.315 135.979 153.312 135.979 153.312C135.921 153.24 135.864 153.167 135.806 153.098C135.801 153.092 135.785 153.092 135.778 153.095C135.742 153.12 135.709 153.15 135.675 153.178ZM136.095 153.225C136.126 153.142 136.075 152.937 136.021 152.889C135.991 152.914 135.958 152.942 135.928 152.966C135.91 152.981 135.91 152.993 135.924 153.009C135.971 153.067 136.018 153.126 136.064 153.184C136.073 153.197 136.083 153.21 136.095 153.225ZM135.634 153.029C135.652 153.014 135.672 153 135.688 152.983C135.693 152.978 135.695 152.958 135.691 152.955C135.633 152.901 135.553 152.88 135.484 152.913C135.469 152.921 135.465 152.929 135.472 152.944C135.497 152.986 135.523 153.027 135.549 153.07C135.558 153.085 135.571 153.084 135.583 153.074C135.599 153.059 135.617 153.044 135.634 153.029ZM135.886 152.821C135.902 152.807 135.917 152.795 135.934 152.781C135.951 152.769 135.955 152.754 135.938 152.739C135.906 152.707 135.874 152.676 135.841 152.646C135.824 152.632 135.813 152.634 135.801 152.653C135.761 152.712 135.761 152.807 135.803 152.862C135.807 152.868 135.825 152.869 135.831 152.866C135.851 152.852 135.868 152.836 135.886 152.821Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M139.581 145.396L143.942 151.313C142.512 156.69 135.432 159.338 132.071 159.991L127.717 153.897C127.717 153.897 128.817 153.42 129.441 152.983C130.189 152.459 131.138 151.375 131.138 151.375L138.208 154.335L136.196 147.439C136.196 147.439 137.5 147.281 138.192 146.855C138.862 146.443 139.581 145.396 139.581 145.396Z",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.206,
    cy: 224.499,
    rx: 14.761,
    ry: 4.01898,
    transform: "matrix(0.852112 -0.524017 0.522702 0.852112 -90.5481 128.156)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 162.796,
    y: 225.326,
    width: 33.1004,
    height: 12.95,
    transform: "rotate(-31.5579 162.796 225.326)",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.204 329.162C220.292 304.279 222.836 296.407 229.508 291.606C236.181 286.805 244.455 286.893 262.368 311.777C280.28 336.661 294.376 381.718 294.376 381.718C274.032 353.457 256.117 354.046 238.204 329.162Z",
    fill: "#FF0000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M240.399 306.735C222.486 281.851 225.03 273.979 231.702 269.178C238.375 264.377 246.649 264.466 264.562 289.35C282.475 314.233 296.57 359.29 296.57 359.29C276.227 331.03 258.311 331.619 240.399 306.735Z",
    fill: "#FF0000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M211.412 317.421C193.5 292.537 196.044 284.665 202.716 279.864C209.389 275.063 217.663 275.152 235.576 300.035C253.488 324.919 267.584 369.976 267.584 369.976C247.24 341.715 229.325 342.304 211.412 317.421Z",
    fill: "#FF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0586,
    y: 162.614,
    width: 89.5961,
    height: 175.672,
    transform: "rotate(-31.5579 94.0586 162.614)",
    fill: "#B7B7B7"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.078,
    cy: 288.708,
    rx: 44.798,
    ry: 17.7103,
    transform: "rotate(-31.5579 224.078 288.708)",
    fill: "#B7B7B7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.661 109.625L90.3148 156.516L182.12 305.99C182.133 306.012 182.147 306.034 182.16 306.056C182.174 306.078 182.188 306.1 182.201 306.122L182.255 306.209L182.256 306.208C187.539 314.345 208.649 310.571 229.602 297.702C250.556 284.832 263.467 267.711 258.598 259.319L258.6 259.318L166.661 109.625Z",
    fill: "url(#paint0_linear_6_1185)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6747 155.477C107.929 185.198 184.378 138.244 166.124 108.522C141.163 67.8822 75.3091 47.7458 75.3091 47.7458C75.3091 47.7458 64.5266 114.533 89.6747 155.477Z",
    fill: "url(#paint1_linear_6_1185)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.178 314.092L172.792 290.991L120.813 206.361C120.813 206.361 110.031 273.148 135.178 314.092Z",
    fill: "url(#paint2_linear_6_1185)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M286.854 220.934L249.241 244.036L197.263 159.406C197.263 159.406 261.707 179.989 286.854 220.934Z",
    fill: "url(#paint3_linear_6_1185)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.469,
    cy: 220.023,
    rx: 29.9748,
    ry: 37.7669,
    transform: "rotate(-31.5579 178.469 220.023)",
    fill: "#EDEDED"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.468,
    cy: 220.023,
    rx: 25.0134,
    ry: 33.2266,
    transform: "rotate(-31.5579 178.468 220.023)",
    fill: "#888888"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02007,
    cy: 3.17442,
    rx: 2.02007,
    ry: 3.17442,
    transform: "matrix(0.92836 -0.373812 0.372706 0.927093 131.684 166.524)",
    fill: "black"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02007,
    cy: 3.17442,
    rx: 2.02007,
    ry: 3.17442,
    transform: "matrix(-0.759429 0.651817 0.651172 0.757876 152.212 153.404)",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.192 153.512C134.802 155.628 129.139 161.139 133.6 166.256C136.59 169.686 136.153 171.754 135.681 173.99C135.272 175.923 134.837 177.981 136.569 181.153C138.142 184.035 140.101 185.529 142.056 187.02C144.744 189.07 147.424 191.114 149.085 196.744C151.38 204.527 163.032 223.711 168.619 232.209L181.286 224.43L181.286 224.43L193.811 216.818C188.842 207.944 177.47 188.841 171.62 183.218C167.499 179.257 167.541 176.007 167.584 172.768C167.617 170.261 167.65 167.759 165.751 164.938C163.722 161.923 161.203 161.369 158.779 160.836C156.004 160.226 153.352 159.643 151.693 155.43C149.206 149.113 141.706 151.601 138.267 153.635L138.192 153.512Z",
    fill: "white"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.88203,
    cy: 6.87666,
    rx: 4.88203,
    ry: 6.87666,
    transform: "matrix(-0.550344 0.835582 0.835391 0.548677 138.977 173.837)",
    fill: "url(#paint4_radial_6_1185)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.88203,
    cy: 6.87666,
    rx: 4.88203,
    ry: 6.87666,
    transform: "matrix(-1.00003 -0.0247954 -0.0263083 0.999312 167.419 163.001)",
    fill: "url(#paint5_radial_6_1185)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.093 202.037C178.413 211.456 165.675 217.263 159.963 218.045L161.826 220.978C175.2 219.979 184.03 209.845 186.937 204.947L185.093 202.037Z",
    fill: "#005BBB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M186.906 204.84C179.181 216.554 167.484 220.093 161.775 220.944L163.284 223.213C176.668 222.051 186.04 213.048 188.86 208.127L186.906 204.84Z",
    fill: "#FFD500"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 0.905879,
    cy: 1.42353,
    rx: 0.905879,
    ry: 1.42353,
    transform: "matrix(0.992509 -0.126642 0.125254 0.991564 151.018 154.994)",
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 0.905879,
    cy: 1.42353,
    rx: 0.905879,
    ry: 1.42353,
    transform: "matrix(0.992509 -0.126642 0.125254 0.991564 132.909 166.374)",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M139.661 171.644C134.055 163.309 141.425 156.87 141.454 156.997C151.086 154.179 154.833 162.023 155.204 163.295C156.225 166.797 162.867 166.405 163.272 170.455C163.677 174.504 167.668 181.027 169.204 186.335C170.145 189.588 169.623 191.303 168.973 192.053C169.19 191.924 169.106 191.99 168.898 192.135C168.722 192.316 168.541 192.43 168.38 192.487C168.573 192.358 168.762 192.23 168.898 192.135C168.923 192.109 168.948 192.082 168.973 192.053C168.687 192.223 167.882 192.73 166.159 193.837C161.297 196.96 157.058 190.679 148.308 185.874C139.558 181.069 146.668 182.063 139.661 171.644Z",
    fill: "#FF6B0A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M164.249 190.696C160.09 192.75 153.497 184.774 150.72 180.528C152.823 178.519 157.63 174.575 160.038 174.866C163.047 175.23 169.448 188.127 164.249 190.696Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M164.378 189.099C166.932 187.074 162.389 181.563 159.798 179.06L154.43 182.323C156.681 185.425 161.823 191.124 164.378 189.099Z",
    fill: "#956C7C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M162.758 187.123C163.081 186.369 158.615 180.898 156.341 178.256L155.238 179.099C157.61 182.088 162.435 187.877 162.758 187.123Z",
    fill: "#86616F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.095 178.177C146.317 170.889 142.853 168.692 141.218 168.505C142.04 160.515 148.76 160.801 152.016 161.943C152.238 169.399 151.888 163.539 159.128 170.865C164.919 176.725 161.805 181.806 159.524 183.614C155.705 184.838 147.873 185.464 147.095 178.177Z",
    fill: "#EB6005"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M161.202 173.519C149.672 168.783 148.821 177.893 149.836 183.04C151.46 184.415 155.705 186.441 159.691 183.547C163.677 180.652 162.359 175.655 161.202 173.519Z",
    fill: "#EFE5D5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153.494 176.724C152.981 176.036 151.913 174.836 151.743 175.54C151.574 176.245 152.84 176.623 153.494 176.724Z",
    fill: "#DACAB0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M154.886 175.882C154.395 175.178 153.593 173.785 154.315 173.847C155.038 173.909 154.997 175.229 154.886 175.882Z",
    fill: "#DACAB0"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.206,
    cy: 224.499,
    rx: 14.761,
    ry: 4.01898,
    transform: "matrix(0.852112 -0.524017 0.522702 0.852112 -90.5481 128.156)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162.796,
    y: 225.326,
    width: 33.1004,
    height: 12.95,
    transform: "rotate(-31.5579 162.796 225.326)",
    fill: "url(#paint6_linear_6_1185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_1185",
    x1: 117.618,
    y1: 195.909,
    x2: 243.573,
    y2: 160.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_1185",
    x1: 89.3599,
    y1: 149.895,
    x2: 161.228,
    y2: 47.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_1185",
    x1: 123.416,
    y1: 292.446,
    x2: 167.895,
    y2: 245.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_1185",
    x1: 272.867,
    y1: 200.655,
    x2: 210.825,
    y2: 219.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6_1185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.88203 6.87666) rotate(90) scale(6.87666 4.88203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBBBB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6_1185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.88203 6.87666) rotate(90) scale(6.87666 4.88203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBBBB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_1185",
    x1: 179.346,
    y1: 225.326,
    x2: 179.346,
    y2: 238.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888888"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.14237179a95112e3162dcd8bfe7a5c1d.svg";
export { ForwardRef as ReactComponent };